import request from '@/utils/request'

export function getSolutionTypeList() {
    return request({
        url: '/website/pc/solution/type/list',
        method: 'get'
    })
}

export function getSolutionListByTypeId(typeId) {
    return request({
        url: '/website/pc/solution/list?typeId=' + typeId,
        method: 'get'
    })
}

export function getSolution() {
    return request({
        url: '/website/pc/solution',
        method: 'get'
    })
}

export function getClassifySolutionByTypeId(typeId) {
    return request({
        url: '/website/pc/solution/classify/' + typeId,
        method: 'get'
    })
}

export function getSolutionByTypeId(typeId) {
    return request({
        url: '/website/pc/solution/' + typeId,
        method: 'get'
    })
}